import { render } from "./Order.vue?vue&type=template&id=389433c8&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import "./Order.vue?vue&type=style&index=0&id=389433c8&lang=scss&scoped=true"

import exportComponent from "/Users/mac/Desktop/HMM-Projects/posvue-version-one/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-389433c8"]])

export default __exports__